import view from '@/mixins/view'

import { populate, sort, filter } from '@/data'

export default {
  name: 'single-activity',
  mixins: [view],
  data () {
    return {
      page: null,
      works: []
    }
  },
  created () {
    this.getPage().then(() => {
      if (!this.page) this.$router.push({ name: 'not-found' })
      this.ready = true
    })
  },
  methods: {
    fetchData: async function (store, params) {
      return Promise.all([
        store.getters.get(params.post_type, params.slug, true),
        store.getters.get('work'),
        store.getters.get('partner'),
        store.getters.get('post')
      ]).then(([page, works, partners, posts]) => {
        return { page, works, partners, posts }
      })
    },
    getPage: async function () {
      await this.fetchData(this.$store, Object.assign({}, this.$attrs, this.$route.params)).then(({ page, works, partners, posts }) => {
        page = populate(page, posts, 'posts')
        this.page = page
        works = sort(works, 'title', 'asc')
        works = filter(works, 'activities', page.id)
        works = populate(works, partners, 'partner')
        this.works = works
      })
    }
  }
}
